<template>
  <div class="content-body tenant-settings">
    <div class="">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="queryHandle()" size="small">
        <el-form-item label="内向交货单号:">
          <el-input size="small" v-model="dataForm.innerCode" placeholder="内向交货单号" clearable @blur="queryHandle"></el-input>
        </el-form-item>
        <el-form-item label="箱标签号:">
          <el-input size="small" v-model="dataForm.boxlabel" placeholder="箱标签号" clearable @blur="queryHandle"></el-input>
        </el-form-item>

        <el-form-item label="供应商代码:">
          <el-input size="small" v-model="dataForm.supplierCode" placeholder="供应商代码" clearable @blur="queryHandle"></el-input>
        </el-form-item>
        <el-form-item label="供应商名称:">
          <el-input size="small" v-model="dataForm.supplierName" placeholder="供应商名称" clearable @blur="queryHandle"></el-input>
        </el-form-item>
        <el-form-item label="打印状态:">
          <el-select size="small" v-model="dataForm.printStatus" placeholder="打印状态" clearable @change="queryHandle">
            <el-option v-for="item in PRINT_STATUS" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="同步状态:">
          <el-select size="small" style="width:100px" v-model="dataForm.syncStatus" placeholder="状态" clearable @change="queryHandle">
            <el-option v-for="item in SYNC_STATUS_PRICE" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供货日期:">
          <el-date-picker
              v-model="dataForm.demandDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @blur="getDataList"
              value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>

        <el-form-item class="fr">
          <el-button size="small" @click="queryHandle()" icon="el-icon-search">
            查询
          </el-button>
          <el-button size="small" @click="printSelectedRows()" icon="el-icon-receiving" :disabled="multipleSelection.length === 0">
            打印
          </el-button>
          <el-button size="small" @click="syncAsnBatch()" icon="el-icon-refresh" :disabled="!canSyncSelected()">
            同步
          </el-button>
        </el-form-item>
      </el-form>
      <div v-loading="dataListLoading">
        <el-table @selection-change="handleSelectionChange" :data="dataList" row-key="id" size="mini" border style="width: 100%;" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}" :height="tableHeight">
          <!-- 添加多选框 -->
          <el-table-column
              type="selection"
              width="55">
          </el-table-column>
          <el-table-column type="index" width="50" label="序号">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column prop="printStringStatus" header-align="center" align="center" label="打印状态" width="100">
            <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.printStringStatus)">
                            {{printStatusFormat(scope.row.printStringStatus)}}
                        </span>
            </template>
          </el-table-column>
          <el-table-column prop="syncStatus" header-align="center" align="center" label="同步状态" width="100">
            <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.syncStatus)">
                            {{syncStatusFormat(scope.row.syncStatus)}}
                        </span>
            </template>
          </el-table-column>
          <el-table-column prop="supplierCode" header-align="center" width="100" align="left" label="供应商代码">
          </el-table-column>
          <el-table-column prop="supplierName" header-align="center" width="200" align="left" label="供应商名称">
          </el-table-column>
          <el-table-column prop="innerCode" header-align="center" align="right" label="内向交货单号"  width="100">
          </el-table-column>
          <el-table-column prop="labelCode" header-align="center" align="right" label="箱标签号"  width="100">
          </el-table-column>
          <el-table-column prop="partCode" header-align="center" align="right" label="零件号" width="150">
          </el-table-column>
          <el-table-column prop="partName" header-align="center" width="60" align="center" label="零件名称">
          </el-table-column>
          <el-table-column prop="deliveryAddress" header-align="center" width="100" align="center" label="卸货地址">
          </el-table-column>
          <el-table-column prop="deliveryDate" header-align="center" width="200" align="left" label="发货日期">
          </el-table-column>
          <el-table-column prop="syncMessage" header-align="center" width="120" align="left" label="同步信息报错">
          </el-table-column>
          <el-table-column header-align="center" align="center" label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="exportBoxLabelData(scope.row)" icon="el-icon-view">
                打印
              </el-button>
              <el-button type="text"
                         :disabled="scope.row.syncStringStatus==='1'"
                         size="small" @click = "syncAsnSingle(scope.row)"
                         icon="el-icon-refresh">
                同步
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
      <!-- 添加纸张选择对话框 -->
      <el-dialog
          title="选择打印纸张"
          :visible.sync="paperSelectVisible"
          width="50%"
          :close-on-click-modal="false"
          :show-close="false"
          class="paper-dialog"
      >
        <div class="paper-selection">
          <el-radio-group v-model="selectedPageType" @change="handlePageTypeChange">
            <el-radio :label="3" border class="paper-radio">
              <div class="paper-option">
                <span class="paper-title">A4纸打印（每页4个标签，120*80）</span>
              </div>
            </el-radio>
            <el-radio :label="1" border class="paper-radio">
              <div class="paper-option">
                <span class="paper-title">标签纸打印（每页1个标签，100*80）</span>
              </div>
            </el-radio>
            <el-radio :label="2" border class="paper-radio">
              <div class="paper-option">
                <span class="paper-title">标签纸打印（每页1个标签，120*80）</span>
              </div>
            </el-radio>
          </el-radio-group>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="paperSelectVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmPaperSelection">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getLabelByValue,
  SYNC_STATUS,
  SYNC_STATUS_PRICE,
  PRODUCTION_ORDER_STATUS,
} from "@/utils/const";
import {
  getGroupList,
  getCurrentUserDataAuthority
} from "@/controller/order"
import {
  fetchDeliveryList,
  deleteDelivery,
  exportDelivery,
  editDelivery,
  syncDelivery,
  exportAsnData,
  printBoxLabelManager
} from '@/controller/delivery'
import {queryBoxLabel, pushBoxLabel} from '@/controller/portal'
import moment from 'moment'
import { PRINT_STATUS } from "../../../../utils/const";
import dayjs from 'dayjs'
export default {
  data() {
    return {
      documentClientHeight: document.documentElement['clientHeight'] - 250,
      dataForm: {
        innerCode:'',
        asncode: '',
        boxlabel: '',
        supplierCode:'',
        supplierName: '',
        printStatus: '',
        syncStatus: '',
        demandDate: [
          dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().format('YYYY-MM-DD HH:mm:ss')
        ]
      },
      multipleSelection: [], // 添加多选数据
      SYNC_STATUS_PRICE:SYNC_STATUS_PRICE,
      dataList: [],
      PRINT_STATUS:PRINT_STATUS,
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      // 添加打印相关数据
      paperSelectVisible: false,      // 控制纸张选择对话框显示
      selectedPageType: null,            // 默认未选择
      currentPrintRow: null         // 保存当前要打印的行数据
    }
  },
  components: {

  },
  activated() {
    this.getDataList()
  },
  computed: {
    tableHeight: {
      get() {
        return this.$store.state.common.documentClientHeight - 310
      }
    }
  },
  methods: {
    canSyncSelected() {
      // 如果没有选中任何项，则不能同步
      if (this.multipleSelection.length === 0) {
        return false;
      }

      // 检查所有选中的项，如果其中有任何一项的syncStatus为'1'，则不能同步
      return !this.multipleSelection.some(item => item.syncStringStatus === '1');
    },
    // 添加多选处理方法
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 添加打印相关方法
    // 新增方法：打印选中的行
    printSelectedRows() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请先选择要打印的数据');
        return;
      }

      // 保存当前选中的行数据并显示纸张选择对话框
      this.currentPrintRow = this.multipleSelection;
      this.paperSelectVisible = true;
      // 默认选中A4纸打印
      this.selectedPageType = 3;
    },
    // 修改原有的箱标签打印方法
    exportBoxLabelData(rec) {
      // 不直接打印，而是先保存当前行数据并显示纸张选择对话框
      this.currentPrintRow = [rec];
      this.paperSelectVisible = true;
      // 默认选中A4纸打印
      this.selectedPageType = rec.pageType || 3;
    },
    // 新增方法：确认纸张选择并执行打印
    confirmPaperSelection() {
      if (this.currentPrintRow && this.currentPrintRow.length > 0) {
        // 创建一个新的对象，避免修改原始数据
        // 处理所有选中的行数据
        const printDataList = this.currentPrintRow.map(row => {
          // 创建一个新的对象，避免修改原始数据
          const printData = {
            ...row,
            pageType: this.selectedPageType
          };

          // 如果存在deliveryDate且为日期字符串，转换格式
          if (printData.deliveryDate && typeof printData.deliveryDate === 'string' && printData.deliveryDate.includes('T')) {
            // 将 "2025-08-28T00:00:00" 格式转换为 "2025-08-28 00:00:00" 格式
            printData.deliveryDate = printData.deliveryDate.replace('T', ' ');
          }

          return printData;
        });

        // 调用打印接口，并传递pageType参数
        // 调用批量打印接口，传递整个数据数组
        printBoxLabelManager(printDataList).then(data => {
          if (data && data.code === '00') {
            this.readAsBinaryString1(data.body);
            this.$message({
              message: `打印操作成功，共打印${printDataList.length}个标签`,
              type: 'success',
              duration: 1500
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      }

      this.paperSelectVisible = false;
      this.currentPrintRow = null;
    },
    // 复用portal中的打印方法
    readAsBinaryString1(data) {
      // 将二进制字符串转换为ArrayBuffer
      const byteCharacters = atob(data.content);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {type: 'application/pdf'});

      // 创建隐藏的iframe用于打印
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = URL.createObjectURL(blob);

      // 监听iframe加载完成事件
      iframe.onload = function () {
        try {
          // 等待一小段时间确保PDF完全加载
          setTimeout(() => {
            // 调用iframe内部的打印功能
            if (iframe.contentWindow) {
              iframe.contentWindow.focus();
              iframe.contentWindow.print();
            }
            // 打印完成后可以选择移除iframe
            // setTimeout(() => document.body.removeChild(iframe), 1000);
          }, 1000);
        } catch (error) {
          console.error('打印失败:', error);
          alert('打印失败，请尝试下载后打印。');
          // 提供下载备选方案
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = decodeURI(data.fileName);
          a.click();
        }
      };

      // 添加iframe到文档
      document.body.appendChild(iframe);
    },
    syncAsnBatch() {
      if (!this.canSyncSelected()) {
        this.$message.warning('选中的数据中包含已同步项，无法再次同步');
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '正在处理',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      console.log('www', this.multipleSelection)
      let params = {
        asnCodeList: this.multipleSelection.map((res) => {
          return res.asnCode
        })
      }
      pushBoxLabel(params).then((data) => {
        if (data && data.code === '00') {
          this.$message.success(data.msg);
          loading.close();
          this.getDataList();
        } else {
          this.$message.error(data.msg);
          loading.close();
          this.getDataList();
        }
      }).catch((e) => {
        console.log(e)
        loading.close();
      })
    },
    // 同步ASN
    syncAsnSingle(row) {
      if (row.syncStringStatus === '1') {
        this.$message.warning('该数据已同步，无法再次同步');
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '正在处理',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      let params = {
        asnCodeList: [row.asnCode]
      }
      pushBoxLabel(params).then((data) => {
        if (data && data.code === '00') {
          this.$message.success(data.msg);
          loading.close();
          this.getDataList();
        } else {
          this.$message.error(data.msg);
          loading.close();
          this.getDataList();
        }
      }).catch((e) => {
        console.log(e)
        loading.close();
      })
    },
    getStatusClass(status) {
      let className = ''
      switch (status) {
        case '0':
          className = "text-primary"
          break;
        case '1':
          className = 'text-success'
          break;
        case '2':
          className = "text-danger"
          break;
        default:
          break;
      }
      return className
    },
    printStatusFormat: function (value) {
      if (value == null) {
        return "";
      }
      return getLabelByValue(PRINT_STATUS, value);
    },
    syncStatusFormat: function (value) {
      if (value == null) {
        return "";
      }
      return getLabelByValue(SYNC_STATUS_PRICE, value);
    },
    // 查询按钮
    queryHandle() {
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      queryBoxLabel({
        pageNo: this.pageIndex,
        pageSize: this.pageSize,
        innerCode:this.dataForm.innerCode,
        asncode: this.dataForm.asncode,
        supplierCode: this.dataForm.supplierCode,
        supplierName: this.dataForm.supplierName,
        boxlabel: this.dataForm.boxlabel,
        printStatus: this.dataForm.printStatus,
        deliDateList: this.dataForm.demandDate || [],
        syncStatus: this.dataForm.syncStatus,
        labelCode: this.dataForm.labelCode
      }).then(data => {
        if (data && data.code === '00') {
          this.dataList = data.body.records;
          this.totalPage = data.body.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      }).catch((e) => {
      }).finally(() => {
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 同步ASN
    syncAsn(row) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let params = {
        id : row.id
      }
      syncDelivery(params).then((data) => {
        if (data && data.code === '00') {
          this.$message.success(data.msg);
          loading.close();
          this.getDataList();
        } else {
          this.$message.error(data.msg);
          loading.close();
          this.getDataList();
        }
      }).catch((e) => {
        console.log(e)
        loading.close();
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.button-danger {
  color: #F56C6C
}

.text-danger {
  color: #F56C6C
}

.text-success {
  color: #67C23A
}

.text-waming {
  color: #E6A23C;
}

.text-info {
  color: #909399;
}

.fr {
  float: right;
}
.demo-block-control {
  border-top: 1px solid #eaeefb;
  height: 44px;
  box-sizing: border-box;
  background-color: #fff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  text-align: center;
  margin-top: -1px;
  color: #d3dce6;
  cursor: pointer;
  position: relative;
}
.heightheight {
  display: none;
}
// 纸张选择区域样式
.paper-selection {
  display: flex;
  gap: 20px;
  justify-content: center; // 让选项居中排列更美观
  padding: 10px 0;

  .paper-radio {
    // 调整外框大小（宽度和高度）
    width: 280px; // 固定宽度，根据需要调整
    height: 100px; // 增加高度，让外框更大
    // 增大下边距
    margin-bottom: 20px; // 调整此值控制下边距大小
    // 其他样式保持不变
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center; // 文字垂直居中
    border: 1px solid #dcdcdc;
    border-radius: 6px; // 稍微增大圆角更美观
    padding: 15px;
    box-sizing: border-box;
    cursor: pointer;
    transition: all 0.2s; // 增加过渡效果

    // 选中状态样式强化
    &:checked {
      border-color: #409eff; // 选中时边框变色
      background-color: #f0f7ff; // 轻微背景色变化
    }

    // 悬停效果
    &:hover {
      border-color: #409eff;
    }
  }

  .paper-radio:nth-child(2) {
    margin-left: 10px; /* 根据实际偏差调整数值，比如 -10px 等 */
  }

  .paper-option {
    text-align: center;
  }

  .paper-title {
    font-size: 15px; // 稍微增大字体
    font-weight: 500;
  }
}
</style>
